module.exports = __webpack_public_path__ + "img/background_active_img_one.c498661c.png";